export default {
    locationcd: '事業所',
    issuingday: '起票日',
    issuingcd: '起票者'
};
